export default "__VITE_ASSET__5fc020fb__"